export default {
    tabbar: {
        home: 'Дом',
        trading: 'Торговля',
        invest: 'Вложить',
        share: 'Делиться',
        mine: 'Мой'
    },
    common: {
        deposit: 'Депозит',
        withdrawal: 'Снятие',
        share: 'Делиться',
        team: 'Команда',
        task: 'Задача',
        addr: 'Адрес',
        logout: 'Выйти',
        wallet: 'Кошелек',
        account: 'Счет',
        promotion: 'Повышение',
        details: 'Подробности',
        dailyRevenue: 'ежедневный доход',
        dailyRevenueList: 'Список ежедневных доходов',
        aboutUs: 'О нас',
        globalPartners: 'Глобальные партнеры',
        totalBalance: 'Итоговый баланс',
        profitList: 'Список финансовой прибыли',
        notification: 'Уведомление',
        previous: 'Предыдущий',
        close: 'Закрывать',
        next: 'Следующий',
        investWallet: 'Инвестиционный кошелек',
        financialWallet: 'Финансовый кошелек',
        recharge: 'Перезарядка',
        copySucceeded: 'копирование выполнено успешно',
        copyFailed: 'копирование не удалось',
        promotionWallet: 'Промо-кошелек',
        registerRewardWallet: 'Зарегистрировать кошелек наград',
        toAddress: 'Адрес кошелька TRON (начинается с T) для сбора',
        verifyYourPassword: 'Подтвердите свой пароль безопасности',
        serviceFee: 'Gas fees',
        confirm: 'Подтверждать',
        submitted: 'поданный',
        date: 'Дата',
        amount: 'Количество',
        accountAvailableBalance: 'Доступный баланс счета',
        securityPassword: 'Пароль безопасности',
        withdrawalPrincipal: 'Вывод основной суммы долга',
        withdrawalProfit: 'Вывод прибыли',
        profitRate: 'Процентная ставка',
        notificationAndFAQ: 'FAQ и уведомления',
        FAQ: 'FAQ',
        FAQs: [
            {
                id: 'q1',
                title: 'Q:Особенности проекта/введение',
                content: `R:
1. Будучи первым в отрасли проверенным инвестиционным кодексом, наше решение призвано доказать, что смарт-контракты — это будущее инвестиций. Его долговечность и стабильность в конечном итоге изменят криптоиндустрию и то, как люди думают об инвестировании и торговле. Индустрия традиционных токенов сталкивается со многими проблемами, включая мошенничество с токенами, коврики, волатильность рынка, нечестные разработчики, крающие средства пользователей, и недостаток ликвидности.

2. Имеющийся у нас код надежности основан на структуре решения, и на наше решение никак не повлияют эти и многие другие проблемы, возникающие в криптоиндустрии. Наша платформа не требует рыночной ликвидности. Таким образом, ваши инвестиции и ожидаемый доход в безопасности, поскольку мы не зависим от изменений в отрасли. Вместо этого мы создали решение, основанное на привлекательности новых пользователей, но работающее на смарт-контрактах! Наш код и структура безопасны, имеют гарантированную долговечность и прозрачность. Поэтому у нас очень привлекательная и надежная реферальная программа с подробной и прозрачной статистикой по каждому промоутеру/пользователю. Доходы оригинатора, как и других пользователей, мгновенно добавляются в профиль, и в отличие от других инвестиционных решений DeFi, люди могут мгновенно вывести средства в любое время.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q2',
                title: 'Q:В чем наше преимущество?',
                content: `R:Наши системы проверяются командой безопасности Haze и имеют независимых аудиторов смарт-контрактов.
1. Безопасно и надежно: нет необходимости переводить валюту, USDT зачисляется на ваш кошелек с нулевым риском.
2. Профессиональная стабильность: профессиональный коллектив, стабильная работа в течение года.
3. Низкий порог входа: доля дохода от майнинга узла
4.USD ETHW AI Strategy-C Майнинг-пул: нет необходимости переводить валюту, стабильный доход
5. Мы стремимся создать крупнейшую в мире интегрированную платформу DeFi DEX, IMO и DAO.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q3',
                title: 'Q:Как мне принять участие?',
                content: `R:
1. Кошелек находится в цепочке, а станция кошелька оснащена браузером Dapp.
2. Подключите TRC20 к USDT и поместите их на свой кошелек.
3. Войдите в Gongwang через браузер кошелька.
4. Для участия в этом проекте в вашем кошельке должно быть более 30 trx в качестве комиссии за майнинг.
`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q4',
                title: 'Q:Сколько времени нужно для участия в майнинге?',
                content: `R:Время невозможно вычислить. Обычно это можно сделать в течение 4 часов. При обнаружении других неопределенных причин время может быть увеличено.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q5',
                title: 'Q:Почему нам нужно платить комиссию за майнинг, чтобы обналичить прибыль?',
                content: `R:Потому что в этом процессе участия в майнинге клиенты учитываются только поименно, а плата за майнинг оплачивается майнерами. Полученный доход фактически находится в пуле контрактов, и только заплатив комиссию за майнинг, вы можете обменять его на доход.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q6',
                title: 'Q:Как вывести прибыль?',
                content: `R:После получения USDT в вашем кошельке должно быть небольшое количество TRX для оплаты комиссий за транзакции. Вам нужно заплатить только один раз, и обмен USDT будет завершен в течение одного рабочего дня. Когда вы инициируете вывод средств, вывод USDT будет автоматически отправлен на адрес кошелька узла, к которому вы присоединились. Другие адреса не поддерживаются.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q7',
                title: 'Q:Что такое майнинг ликвидности Defi?',
                content: `R:Майнинг ликвидности — это тип децентрализованного финансирования DeFi. Ему не нужно приобретать видеокарты, предоставлять вычислительную мощность или оплачивать дорогостоящие счета за электроэнергию, он получает доход, предоставляя средства и ликвидность. Особенно в последнее время цены на валюту сильно колебались. Для некоторых преданных держателей монет майнинг ликвидности — это способ получить доход и накопить больше криптовалюты без необходимости проведения транзакций.`,
                updatedAt: '2019-07-23 12:00:00'
            },
            {
                id: 'q8',
                title: 'Q:Как это работает?',
                content: `R:Наше решение представляет собой компьютеризированное соглашение о транзакции, которое автоматически обеспечивает соблюдение условий контракта между двумя сторонами. Как и в случае с универсальными контрактами, оба пользователя нашей платформы должны определить правила и условия участия при торговле. После достижения соглашения и запуска смарт-контракта он работает так, как задумано, с нулевой вероятностью изменения заранее определенных условий. Когда пользователь инициирует активность в майнинг-пуле узла блокчейна, в контракте должен быть доступный баланс. Остальные пользователи оставляют это на усмотрение контракта, и им больше не нужно ждать долгие часы, чтобы проверить, когда продавать или покупать. Поэтому по условиям договора стоимость вашей инвестиции гарантированно никогда не уменьшится; наоборот, это приносит 100% прибыль нашим пользователям.`,
                updatedAt: '2019-07-23 12:00:00'
            }
        ],
        minWithdrawalError: 'Сумма вывода должна быть больше, чем использованная плата за газ.',
        supportTips: 'Уважаемый пользователь! Мы создали для вас эксклюзивную услугу помощника по майнинг-пулу. Вы можете написать нам для консультации, жалоб, предложений и т. д., и мы ответим и разберемся в течение 24 часов!',
        tips: 'Чаевые',
        Withdrawals_prohibited: 'Условия вывода на данный момент не выполнены, пожалуйста, сначала выполните задание.'
    },
    homePage: {
        theCommonProblem: 'Общая проблема',
        latestAnnouncement: 'Последнее объявление',
        block5title: 'Присоединяйтесь и станьте миллионером TRON',
        block5desc: 'Используйте облачный майнинг и технологию Defi, чтобы все пользователи получали максимальный доход в долларах США.',
        block6title: 'Отображение данных платформы',
        accumulatedProfit: 'Накопленная прибыль',
        membership: 'Членство',
        block7title: 'Мы в своих лучших проявлениях',
        block7desc: 'hako — компания, зарегистрированная в Сингапуре, номер лицензии: PS20200556. Мы являемся единственным проверенным и проверенным инвестиционным веб-сайтом со смарт-контрактами в криптовалютном пространстве, работающим в сети TRON Smart Chain (TRON). Облачный майнинг hako предлагает потенциально экономически эффективный конвейер для майнинга биткойнов, USDT и других криптовалют. В то же время как количественная торговля, так и технология DeFi позволят вам легко участвовать в транзакциях блокчейна с небольшим размером капитала и получать стабильный доход, например, в виде страхования.',
        tzl: 'вложено',
        zl: 'заработано'
    },
    investPage: {
        productList: 'Список продуктов',
        investedList: 'Инвестируемый список',
        dailyRate: 'Дневная норма',
        cycle: 'цикл',
        day: 'День',
        productDetails: 'информация о продукте'
    },
    tradingPage: {
        miningWorking: 'Облачный майнинг работает',
        tradingProfit: 'Торговая прибыль',
        settlementRule: 'круглосуточный расчет',
        viewAll: 'Посмотреть все',
        quantifyingTransactionRevenue: 'Качественный торговый доход',
        receive: 'Получать',
        received: 'Полученный',
        rule: 'Правила майнинга',
        rules: 'Если вы хотите, чтобы «Облачный майнинг» начал работать и приносить вам ежедневный доход, активируйте его в «Финансовом кошельке». Когда баланс USDT в вашем кошельке соответствует определенным условиям, вы будете получать ежедневный доход, и полученный доход будет сохраняться в течение 30 дней. Пожалуйста, нажмите, чтобы потребовать его вовремя. Рассчитайте процент ежедневного дохода на основе таблицы ниже:',
        profit: 'Выгода',
        miningNotWorking: 'Облачный майнинг не работает, пожалуйста, активируйте его',
        balance: 'баланс'
    },
    sharePage: {
        text1: 'Пригласите свои контакты',
        text2: 'или Друзья и получайте награды',
        text3: 'Приглашайте и получайте вознаграждения',
        text4: 'Поделитесь своей реферальной ссылкой и начните зарабатывать',
        copyLink: 'Копировать ссылку'
    },
    minePage: {
        trxDepositInvestment: 'USDT Депозитные инвестиции',
        trxDepositFinancial: 'USDT Депозит финансовый',
        tips: 'Пополните любое количество USDT, чтобы активировать учетную запись и открыть функцию вывода средств.',
        appServices: 'Службы приложений'
    },
    depositPage: {
        text1: 'Инвестиции делятся на два режима',
        text2: '1: Пополните инвестиционный кошелек, вы можете получать доход в соответствии с различными циклами, возвращать основную сумму и доход по истечении срока погашения.',
        text3: '2: Активируйте функцию «облачного майнинга» в своем финансовом кошельке и получайте доход в соответствии с часовым поясом Сингапура (после 12 часов) каждый день.',
        text4: 'Примечание:',
        text5: 'Прежде чем инвестировать, выберите инвестиционный счет или финансовый счет для инвестирования в соответствии с вашими инвестиционными потребностями. Обязательно дождитесь пополнения счета. Это очень важный вопрос. '
    },
    rechargePage: {
        trxAddress: 'Адрес TRC20-USDT',
        copyAddress: 'Копировать адрес',
        tips1: 'Пожалуйста, не пополняйте другие активы, отличные от USDT. Он будет записан примерно через 5–10 минут после зарядки.',
        tips2: `Если товар не пришел в течение длительного времени, пожалуйста, обновите эту страницу. Минимум 5 долларов США инвестиций.`,
        rechargeCompleted: 'Пополнение счета завершено',
        inactivated: 'Деактивирован',
        activated: 'Активировано',
        tips3: 'Нет необходимости нажимать повторно. Облачный майнинг начинает работать примерно через 5–10 минут после отправки запроса.',
        tips4: 'Если он не был активирован в течение длительного времени, пожалуйста, нажмите кнопку активации еще раз.',
        ActivateCloudMining: 'Активируйте облачный майнинг'
    },
    withdrawalPage: {
        text1: 'Базовый баланс счета (USDT)',
        text2: 'Вывод будет получен в течение 24 часов',
        dailyWithdrawalLimit: 'Дневной лимит вывода средств',
        unlimit: 'неограниченный'
    },
    teamPage: {
        intro: 'Пользователи, которых вы приглашаете прямо или косвенно, могут получать для вас дивиденды. Предположим, вы приглашаете пользователя А, финансовый доход, полученный пользователем А, будет отправлен на ваш кошелек в виде процентного вознаграждения. Если пользователь A приглашает пользователя B, а B, в свою очередь, приглашает C, вы можете получить процентное вознаграждение A ({lev2rate}%), B ({lev3rate}%), C ({lev4rate}%) от дохода пользователя!',
        level: 'Уровень',
        lev2: 'lv.2',
        lev3: 'lv.3',
        lev4: 'lv.4',
        quantity: 'Количество',
        rewards: 'Награды'
    },
    productDetailsPage: {
        startingAmount: 'Стартовая сумма',
        maxInvestmentAmount: 'Макс. сумма инвестиции',
        dailyInterestRate: 'Ежедневная процентная ставка',
        investableQuantity: 'Инвестиционное количество',
        investmentAmount: 'Сумма инвестиции',
        participateInInvestment: 'Участвуйте в инвестициях'
    },
    investedListPage: {
        investmentTime: 'Инвестиционное время',
        settlementTime: 'Время расчета',
        settlementAmount: 'Сумма расчета'
    },
    loginPage: {
        MobileNumber: 'Mobile number',
        LoginPassword: 'Login password',
        SignIn: 'Sign in',
        SignUp: 'Sign up',
        rememberThePassword: ' remember the password',
        inviteCode: 'Invite code',
        captcha: 'Captcha',
        EncryptedRegistration: 'Encrypted registration',
        desc: 'The password is stored in a decentralized way and cannot be retrieved after it is lost. Please remember your password. ',
        registerSuccess: 'Account created successfully'
    },
    taskPage: {
        desc: 'Каждая эффективная сумма пополнения подчиненных участников, которых вы приглашаете зарегистрироваться, будет конвертирована в ваш лимит вывода средств (счет вознаграждений по акции) в определенной пропорции.',
        rwconvertRate: 'Масштаб преобразования',
        totalLimit: 'Совокупный лимит',
        availableLimit: 'Доступный кредит',
        contactService: 'Свяжитесь со службой поддержки клиентов'
    },
    Please_unlock_your_wallet: 'Пожалуйста, разблокируйте свой кошелек',
    Please_open_the_website_in_the_Dapp_browser: 'Пожалуйста, откройте сайт в браузере Dapp.'
}
